exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___Yn2Qi{display:grid;grid-template-rows:repeat(auto,1fr);-moz-column-gap:1rem;column-gap:1rem;cursor:pointer;margin-top:-2rem}@media (max-width:525px){.index-module__wrapper___Yn2Qi{grid-template-columns:repeat(1,1fr);row-gap:1rem}}@media (min-width:768px){.index-module__wrapper___Yn2Qi{grid-template-columns:repeat(2,1fr);row-gap:1rem}}@media (min-width:1325px){.index-module__wrapper___Yn2Qi{grid-template-columns:repeat(3,1fr);row-gap:1rem}}.index-module__btn___185xm{display:flex;justify-content:space-evenly;align-items:center;padding:1rem;color:#1e265c;margin-top:1.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___Yn2Qi",
	"btn": "index-module__btn___185xm"
};